module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_desktop_5c0a360023c29ec76282baf0071f34d8.webp";